// 사용할 svg Icon
export type iconName = "account" | "lock" | "logout" | "factory" |
    "sun" | "moon" | "search" | "x" | "change" | "caretDown" | "arrow" |
    "expand" | "minimize" | "doubleUp" | "doubleDown" | "excel" |
    "grid" | "gridOff";
type TFillRule = "nonzero" | "evenodd" | "inherit";
type TStrokeLineCap = "inherit" | "butt" | "round" | "square";
type TStrokeLineJoin = "inherit" | "round" | "miter" | "bevel";

type icon = {
    path : string;
    viewBox : string;
    fill? : string;
    fillRule? : TFillRule;
    stroke? : string;
    strokeLinecap? : TStrokeLineCap;
    strokeLinejoin? : TStrokeLineJoin;
    strokeMiterlimit? : string;
    strokeWidth? : string;
    transform? : string;
};

const IconSet: Record<iconName, icon> = {
    account: {
        path : "M15.71,12.71a6,6,0,1,0-7.42,0,10,10,0,0,0-6.22,8.18,1,1,0,0,0,2,.22,8,8,0,0,1,15.9,0,1,1,0,0,0,1,.89h." +
            "11a1,1,0,0,0,.88-1.1A10,10,0,0,0,15.71,12.71ZM12,12a4,4,0,1,1,4-4A4,4,0,0,1,12,12Z",
        viewBox : "0 0 24 24",
    },
    lock : {
        path : "M12,13a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V14A1,1,0,0,0,12,13Zm5-4V7A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0" +
            ",3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9ZM9,7a3,3,0,0,1,6,0V9H9Zm9,12a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z",
        viewBox: "0 0 24 24",
    },
    logout : {
        path : "M4,12a1,1,0,0,0,1,1h7.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76" +
            ",1,1,0,0,0-.21-.33l-4-4a1,1,0,1,0-1.42,1.42L12.59,11H5A1,1,0,0,0,4,12ZM17,2H7A3,3,0,0,0,4,5V8A1,1,0,0,0,6,8V5A1,1," +
            "0,0,1,7,4H17a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V16a1,1,0,0,0-2,0v3a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V5A3,3,0,0,0,17,2Z",
        viewBox : "0 0 24 24",
    },
    factory : {
        path : "M33.16,6.16c-0.13-0.06-0.28-0.04-0.4,0.04l-9.39,7.51V6.5c0-0.14-0.08-0.28-0.21-0.34c-0.13-0.06-0.28-0.04-0.4,0.04\n" +
            "\tl-9.39,7.51V6.5c0-0.14-0.08-0.28-0.21-0.34s-0.28-0.04-0.4,0.04l-10,8c-0.09,0.07-0.14,0.18-0.14,0.29v15\n" +
            "\tc0,0.21,0.17,0.38,0.38,0.38h10h10h10c0.21,0,0.38-0.17,0.38-0.38v-23C33.38,6.36,33.29,6.22,33.16,6.16z M12.63,14.5v14.63H3.38\n" +
            "\tV14.68l9.25-7.4V14.5z M22.63,14.5v14.63h-9.25V14.68l9.25-7.4V14.5z M32.63,29.12h-9.25V14.68l9.25-7.4V29.12z",
        viewBox : "0 0 36 36"
    },
    sun : {
        path : "M5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12ZM5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-" +
            ".71A1,1,0,0,0,5.64,17ZM12,5a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5Zm5.66,2.34a1,1,0,0,0,.7-.29l.71-.71a1," +
            "1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34Zm-12-.29a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0" +
            ",0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1" +
            ",1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5," +
            "3.5,0,0,1,12,15.5ZM12,19a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19Z",
        viewBox : "0 0 24 24",
    },
    moon : {
        path : "M18 9.79A9 9 0 1 1 8.21 0 7 7 0 0 0 18 9.79z",
        viewBox : "0 0 20 20",
        fill : "none",
        fillRule : "evenodd",
        stroke : "#000",
        strokeLinecap : "round",
        strokeLinejoin : "round",
        strokeWidth : "2",
        transform : "translate(1 1)"
    },
    search : {
        path : "M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 " +
            "1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z",
        viewBox : "0 0 24 24"
    },
    x : {
        path : "M12 0L0 12M0 0l12 12",
        viewBox : "0 0 14 14",
        fill : "none",
        fillRule : "evenodd",
        stroke : "#000",
        strokeLinecap : "round",
        strokeLinejoin : "round",
        strokeWidth : "2",
        transform : "translate(1 1)"
    },
    change : {
        path : "M12.945 9.962c.143 0 .285-.034.417-.101l6.495-3.332c.32-.164.517-.5.505-.863s-.23-.685-.56-.828l-6.387-2.764c-.282-.122-.607-.095-.865.075-.259.168-.416.456-.422.767l-.035 " +
            "1.986c-4.971 1.68-8.268 6.37-8.087 11.651.144 4.194 2.542 8.049 6.26 10.059.139.075.288.11.435.11.33 0 " +
            ".649-.179.815-.493.24-.455.071-1.02-.379-1.263-3.139-1.698-5.164-4.946-5.286-8.478-.145-4.224 2.36-8 " +
            "6.207-9.584l-.037 2.107c-.005.327.159.634.434.808C12.604 9.915 12.774 9.962 12.945 9.962zM17.26 5.769l-3.364 1.726.056-3.158L17.26" +
            " 5.769zM27.993 15.744c-.134-3.894-2.184-7.482-5.482-9.599-.434-.277-1.002-.148-1.275.288-.272.435-.145 1.012.285 1.288 " +
            "2.785 1.787 4.516 4.81 4.628 8.087.135 3.918-2.026 7.486-5.472 9.246l-.054-2.106c-.01-.327-.187-.625-.468-.787-.281-.161-.626-.163-.907-.002l-6.347 " +
            "3.602c-.313.178-.495.522-.469.884.027.361.258.674.594.803l6.502 2.492C19.635 29.98 19.745 30 19.855 30c.188 0 .376-.059.534-.172.251-.18.396-.475.389-.785l-.05-1.958C25.265 25.162 28.163 20.688 27.993 15.744zM15.528 26.41l3.288-1.866.081 3.157L15.528 26.41z",
        viewBox : "0 0 32 32"
    },
    caretDown : {
        path : "M215.39111,92.93848A8.00015,8.00015,0,0,0,208,88H48a8,8,0,0,0-5.65674,13.657l80,79.99976a7.99945,7.99945,0,0,0,11.31348,0l80-79.99976A8.00011,8.00011,0,0,0,215.39111,92.93848Z",
        viewBox : "0 0 256 256"
    },
    arrow : {
        path : "M20.5 11.5l-6 6-6-6",
        viewBox : "0 0 29 29",
        fill : "none",
        stroke : "#000",
        strokeLinecap : "round",
        strokeLinejoin : "round",
        strokeMiterlimit : "10",
        strokeWidth : "2"
    },
    expand : {
        path : "M20 5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L18 7.42V10a1 1 0 0 0 1 1 1 1 0 0 0 1-1zM10.71 13.29a1 1 0 0 0-1.42 0L6 16.57V14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.42l3.29-3.29a1 1 0 0 0 0-1.42z",
        viewBox : "0 0 24 24"
    },
    minimize : {
        path : "M3.25,9 L6.20171,9.00155 C6.40941,8.98823 6.62159,9.06093 6.78033,9.21967 C6.91261333,9.35195333 6.98514667,9.52134778 6.99794157,9.69433481 L7.0000025,9.85 L7.0000025,9.85 L7.0000025,12.75 C7.0000025,13.1642 6.66421,13.5 6.25,13.5 C5.83579,13.5 5.5000025,13.1642 " +
            "5.5000025,12.75 L5.5000025,11.5607 L3.28033,13.7803 C2.98744,14.0732 2.51256,14.0732 2.21967,13.7803 C1.92678,13.4874 1.92678,13.0126 2.21967,12.7197 L4.43934,10.5 L3.25,10.5 C2.83579,10.5 2.5000025,10.1642 2.5000025,9.75 C2.5000025,9.33579 2.83579,9 3.25,9 " +
            "Z M12.7197,2.21967 C13.0126,1.92678 13.4874,1.92678 13.7803,2.21967 C14.0465727,2.48593364 14.0707793,2.90260223 13.8529198,3.19621222 L13.7803,3.28033 L11.5607,5.5000025 L12.75,5.5000025 C13.1642,5.5000025 13.5,5.83579 13.5,6.25 C13.5,6.6296925 13.2178347,6.94349252 " +
            "12.8517677,6.99315577 L12.75,7.0000025 L9.79829,6.99845 C9.59059,7.01177 9.37841,6.93907 9.21967,6.78033 C9.08738667,6.64804667 9.01485333,6.47865222 9.00205843,6.30566519 L9,6.15 L9,3.25 C9,2.83579 9.33579,2.5000025 9.75,2.5000025 C10.1296833,2.5000025 10.4434889,2.78215727 " +
            "10.4931531,3.14823024 L10.5,3.25 L10.5,4.43934 L12.7197,2.21967 Z",
        viewBox : "0 0 16 16",
        fill : "#212121"
    },
    doubleUp : {
        path : "M12.71,12.54a1,1,0,0,0-1.42,0l-3,3A1,1,0,0,0,9.71,17L12,14.66,14.29,17a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Zm-3-1.08L12,9.16l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-3-3a1,1,0,0,0-1.42,0l-3,3a1,1,0,0,0,1.42,1.42Z",
        viewBox : "0 0 24 24"
    },
    doubleDown : {
        path : "M11.29,11.46a1,1,0,0,0,1.42,0l3-3A1,1,0,1,0,14.29,7L12,9.34,9.71,7A1,1,0,1,0,8.29,8.46Zm3,1.08L12,14.84l-2.29-2.3A1,1,0,0,0,8.29,14l3,3a1,1,0,0,0,1.42,0l3-3a1,1,0,0,0-1.42-1.42Z",
        viewBox : "0 0 24 24"
    },
    excel : {
        path : "M23.5 2.5H14V1a.5.5 0 0 0-.612-.487l-13 3A.5.5 0 0 0 0 4v17a.5.5 0 0 0 .424.494l13 2A.499.499 0 0 0 14 23v-1.5h9.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-9.5 7h3v2h-3v-2zm-9.924 6.235l2.169-3.47a.497.497 0 0 0 0-.53l-2.168-3.47a.5.5 0 1 1 .847-.53l1.652" +
            " 2.643c.183.292.665.292.848 0l1.652-2.643a.499.499 0 0 1 .689-.16.5.5 0 0 1 .16.689l-2.169 3.47a.497.497 0 0 0 0 .53l2.168 3.47a.5.5 0 0 1-.159.689.513.513 0 0 1-.689-.16L7.424 13.62a.502.502 0 0 0-.848.001l-1.652 2.643a.514.514 0 0 1-.689.16.5.5 0 0 " +
            "1-.159-.689zM14 12.5h3v2h-3v-2zm4 0h5v2h-5v-2zm0-1v-2h5v2h-5zm0-3v-2h5v2h-5zm-1 0h-3v-2h3v2zm-3 7h3v2h-3v-2zm4 0h5v2h-5v-2zm5-10h-5v-2h5v2zm-6-2v2h-3v-2h3zm-3 15h3v2h-3v-2zm4 2v-2h5v2h-5z",
        viewBox : "0 0 24 24",
    },
    grid : {
        path : "M40 4h-32c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 36h-8v-8h8v8zm0-12h-8v-8h8v8zm0-12h-8v-8h8v8zm12 24h-8v-8h8v8zm0-12h-8v-8h8v8zm0-12h-8v-8h8v8zm12 24h-8v-8h8v8zm0-12h-8v-8h8v8zm0-12h-8v-8h8v8z",
        viewBox : "0 0 48 48"
    },
    gridOff : {
        path : "M16 8v2.91l4 4v-6.91h8v8h-6.91l4 4h2.91v2.91l4 4v-6.91h8v8h-6.91l4 4h2.91v2.91l4 4v-30.91c0-2.21-1.79-4-4-4h-30.91l4 4h2.91zm16 0h8v8h-8v-8zm-29.45-5.45l-2.55 2.54 4 4v30.91c0 2.21 1.79 4 4 4h30.91l4 4 2.54-2.55-42.9-42.9zm17.45 22.54l2.91 2.91h-2.91v-2.91zm-12-12l2.91 2.91h-2.91v-2.91zm8 " +
            "26.91h-8v-8h8v8zm0-12h-8v-8h6.91l1.09 1.09v6.91zm12 12h-8v-8h6.91l1.09 1.09v6.91zm4 0v-2.91l2.91 2.91h-2.91z",
        viewBox : "0 0 48 48"
    }
}

export { IconSet };
